import { defineComponent } from "vue";
import appStore, { AUTH_ACTIONS, APP_ACTIONS } from "@/store/app";
import logo from "@/components/commons/logo";
import paths from "@/config/router";

export default defineComponent({
  name: "topHeader",
  components: {
    logo,
  },
  props: {
    compts: Function,
  },
  data() {
    return {
      tabs: [
        {
          component: "intro",
          text: "Intro Video",
          isExternalLink: false,
          link: "#",
        },
        {
          component: "overview",
          text: "Overview",
          isExternalLink: false,
          link: "#",
          permission: "View_Overview",
        },
        {
          component: "newsletter",
          text: "Newsletter",
          isExternalLink: false,
          link: "#",
          permission: "View_Newsletter",
        },
        {
          component: "replay",
          text: "Investor Call Replay",
          isExternalLink: false,
          link: "#",
          cssClass: "multiLine",
          permission: "View_Replay",
        },
        {
          component: "co-investment-opportunities",
          text: "Co-Investment Opportunities",
          isExternalLink: false,
          link: "#",
          cssClass: "multiLine",
          permission: "View_InvestmentOppotunities",
        },
        {
          component: "seeded-companies",
          text: "Portfolio Companies",
          isExternalLink: false,
          link: "#",
          cssClass: "multiLine",
          permission: "View_SeededCompanies",
        },
        {
          component: "",
          text: "Fuel Vault",
          isExternalLink: true,
          link: "https://fuelvc.arkpes.com/login",
          cssClass: "multiLine",
          permission: "View_CornerstonePortal",
        },
        {
          component: "data-room",
          text: "Data Room",
          isExternalLink: false,
          link: "#",
        },
        {
          component: "request-form",
          text: "Request Form",
          isExternalLink: false,
          link: "#",
        },
        {
          component: "event",
          text: "Event",
          isExternalLink: false,
          link: "#",
          permission: "Event_Read",
        },
      ],
      pageSection: "",
      isShowLeftMenu: false,
      profileName: paths.profile.name,
      profilePath: paths.profile.path,
    };
  },
  methods: {
    handleChangeFund() {
      appStore.dispatch(APP_ACTIONS.set_show_lp_funds_investor_popup, true);
    },
    routePage: function (link) {
      // this.$router.push({
      //   path: this.$router.currentRoute.value.path,
      //   query: { t: link },
      // });
      this.pageSection = link;
    },
    logout() {
      appStore.dispatch(AUTH_ACTIONS.logout);
    },
    hideMenu() {
      this.isShowLeftMenu = false;
    },
    swapmenu() {
      this.isShowLeftMenu = !this.isShowLeftMenu;
    },
    menuClass(item) {
      return `${item.cssClass ? item.cssClass : ""} ${
        this.pageSection === item.component
          ? "router-link-exact-active active"
          : ""
      }`;
    },
  },
  computed: {
    isShowSelectLpFund() {
      return appStore.state.profile.lpFunds.length !== 1;
    },
    investorInfo() {
      return appStore.state.investorInfo;
    },
    currentRouteName() {
      return this.$router.currentRoute.value.name;
    },
    profile() {
      return appStore.state.profile;
    },
    username() {
      return (
        this.profile && `${this.profile.firstName} ${this.profile.lastName}`
      );
    },
    deviceVersion() {
      return appStore.state.mobile.version;
    },
  },
  mounted() {
    if (!this.$router.currentRoute.value.query.t) {
      this.pageSection = "intro";
    } else {
      let tab = this.tabs.find(
        (x) => x.component === this.$router.currentRoute.value.query.t
      );
      if (tab) {
        if (tab.permission) {
          if (this.hasPermission(tab.permission)) {
            this.pageSection = tab.component;
          } else {
            this.$router.push({
              path: this.$router.currentRoute.value.path,
              query: { t: "intro" },
            });
            this.pageSection = "intro";
          }
        } else {
          this.pageSection = tab.component;
        }
      } else {
        this.$router.push({
          path: this.$router.currentRoute.value.path,
          query: { t: "intro" },
        });
        this.pageSection = "intro";
      }
    }
  },
  watch: {
    pageSection: function (v) {
      this.compts(v);
    },
  },
});
